import "./returnOnInvestment.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";

import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

const ReturnOnInvestment = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Return on Investment"
  );
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  let et = roofInfo?.value?.financialAnalysis?.et
    ? Number(roofInfo.value.financialAnalysis.et)
    : 0;
  let maintenceCost = roofInfo?.value?.financialAnalysis?.maintenceCost
    ? Number(roofInfo.value.financialAnalysis.maintenceCost)
    : 0;
  let TPC = roofInfo?.value?.financialAnalysis?.tpc
    ? Number(roofInfo.value.financialAnalysis.tpc) + maintenceCost
    : 0 + maintenceCost;
  const aeci = roofInfo?.value?.financialAnalysis?.aeci
    ? parseFloat(roofInfo.value.financialAnalysis.aeci)
    : 0;
  let expTariff = roofInfo?.value?.financialAnalysis?.exportTriff
    ? parseFloat(roofInfo.value.financialAnalysis.exportTriff)
    : 0;
  const aetIncrease = roofInfo?.value?.financialAnalysis?.aetIncrease
    ? parseFloat(roofInfo.value.financialAnalysis.aetIncrease)
    : 0;
  const roiYears = roofInfo?.value?.financialAnalysis?.roiYears || 20;
  const currency = roofInfo?.value?.financialAnalysis?.currency || "PKR";
  // Enhancement In ROI CHart by Irtaza

  let kWhGen = [];
  if (check) {
    for (let j = 0; j < 12; j++) {
      let val = 0;
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i].actualGeneration;
        val += element[j];
      }
      kWhGen.push(val);
    }
  } else {
    for (let j = 0; j < 12; j++) {
      const element = roofDetail.actualGeneration;
      const val = element[j];
      kWhGen.push(val);
    }
  }

  // financialAnalysis yearly calculation
  let yearlySave = [];
  let financialAnalysis = [];
  let remainingTPC = TPC;
  for (let i = 1; i <= roiYears; i++) {
    let consumeUnit = [];
    let exportUnit = [];
    let newKWhGen = [];
    for (let j = 0; j < 12; j++) {
      let monthGen = kWhGen[j];
      if (i > 1) {
        monthGen = kWhGen[j] - kWhGen[j] * 0.0055;
      }
      newKWhGen.push(monthGen);
      const monthUnit = roofInfo.value.financialAnalysis[month[j]];
      if (monthGen > monthUnit) {
        consumeUnit.push(monthUnit);
        exportUnit.push(monthGen - monthUnit);
      } else {
        consumeUnit.push(monthGen);
        exportUnit.push(0);
      }
    }

    if (i > 1) {
      et = Number((et + et * (aeci / 100)).toFixed(2));
      expTariff = Number(
        (expTariff + expTariff * (aetIncrease / 100)).toFixed(2)
      );
    }
    const yearConUnit = Object.values(consumeUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const yearExpUnit = Object.values(exportUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const expSave = yearExpUnit * expTariff;
    const conSave = yearConUnit * et;
    const yearSave = expSave + conSave;
    if (i === 1) {
      remainingTPC = yearSave - TPC;
    } else {
      remainingTPC = remainingTPC + yearSave;
    }

    yearlySave.push(yearSave);
    financialAnalysis.push(remainingTPC);
    kWhGen = newKWhGen;
  }

  // const totalSave = Object.values(yearlySave).reduce(
  //   (sum, val) => sum + val,
  //   0
  // );
  // const ROIPERCENTAGE = Number(((totalSave / roiYears / TPC) * 100).toFixed(2));

  let givenData = {
    ROI: financialAnalysis,
  };
  let neg = givenData.ROI.map((item, index) => {
    if (item < 0) {
      return item;
    }
    return null;
  });
  let pos = givenData.ROI.map((item, index) => {
    if (item > 0) {
      return item;
    }
    return null;
  });

  let options = {
    responsive: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        // stacked: true,
        ticks: { color: "#929292", font: { size: 8 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Year", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        // stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 10 },
        // beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: `ROI (${currency})`, // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  const generateLabels = (limit) => {
    return Array.from({ length: limit }, (_, i) => (i + 1).toString());
  };

  let state = {
    data: {
      labels: generateLabels(roiYears),
      datasets: [
        {
          stack: "Stack 0",
          label: `Recovery (${currency})`,
          backgroundColor: "#FF7C1B",
          data: neg,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 0",
          label: `Profit (${currency})`,
          backgroundColor: "#045097",
          data: pos,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  return (
    <div id="return-of-investment" className="return-of-investment">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="roi-body">
        <p style={{ marginTop: "30px", marginBottom: "20px" }}>
          Return on Investment
        </p>
        <Bar height="340px" width="495px" options={options} data={state.data} />
        <div className="chart-ball-text-container">
          {chartBallText(state.data.datasets)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ReturnOnInvestment;
